/* eslint-disable import/no-cycle */
import {
	all, call, fork, takeLatest,
} from 'redux-saga/effects';
import api from '../../../services/api';
import ToastHelper from '../../../utils/toastHelper';
import { Types } from '../../ducks/comum/download';

function* asyncFile(action) {
	try {
		const { arquivo, callback } = action;

		let url = '/download/file/?';

		if (arquivo.key) {
			url += `key=${arquivo.key}&id=`;
		} else if (arquivo.id) {
			url += `id=${arquivo.id}&key=`;
		}

		const response = yield call(api.get, url, { responseType: 'arraybuffer' });

		callback(response.data);
	} catch (error) {
		ToastHelper.error('Falha ao baixar o documeto.');
	}
}

function* downloadFile() {
	yield takeLatest(Types.DOWNLOAD_FILE, asyncFile);
}

export default function* root() {
	yield all([fork(downloadFile)]);
}
